export default "__VITE_ASSET__CZBARwhk__"